import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ComponentDisplayService {
  showNavigation = true;
  showLanguageSwitcher = true;
  showCurrencySwitcher = true;
  showHeader = true;

  readonly onShowNavigationChange: EventEmitter<boolean> = new EventEmitter();
  readonly onShowLanguageSwitcherChange: EventEmitter<boolean> = new EventEmitter();
  readonly onShowCurrencySwitcherChange: EventEmitter<boolean> = new EventEmitter();
  readonly onShowHeaderChange: EventEmitter<boolean> = new EventEmitter();

  /**
   * Sets showNavigation to true or false
   * @param show
   * @emits onShowNavigationChange (hide or show navigation)
   */
  setShowNavigation(show: boolean) {
    this.showNavigation = show;
    this.onShowNavigationChange.emit(show);
  }

  /**
   * Sets showLanguageSwitcher to true or false
   * @param show
   * @emits onShowLanguageSwitcherChange (hide or show navigation)
   */
  setShowLanguageSwitcher(show: boolean) {
    this.showLanguageSwitcher = show;
    this.onShowLanguageSwitcherChange.emit(show);
  }

  /**
   * Sets showCurrencySwitcher to true or false
   * @param show
   * @emits onShowCurrencySwitcherChange (hide or show navigation)
   */
  setShowCurrencySwitcher(show: boolean) {
    this.showCurrencySwitcher = show;
    this.onShowCurrencySwitcherChange.emit(show);
  }
  /**
   * Sets website header to true or false
   * @param show
   * @emits onShowHeaderChange (hide or show header)
   */
  setHeader(show: boolean) {
    this.showHeader = show;
    this.onShowHeaderChange.emit(show);
  }
}
